import {FlowSteps} from '../constants/flowSteps.mjs';

export default {
  loginFlowEnabled: false,
  employees: [],
  employeeConflicts: [],
  branches: [],
  selectedEmployee: {},
  processing: false,
  loginComplete: false,
  hasLoggedOut: false,
  flowSteps: {
    [`${FlowSteps.PROFILE_SELECTED}`]: false,
    [`${FlowSteps.BRANCH_SELECTED}`]: false,
    [`${FlowSteps.LOGGED_IN}`]: false
  },
};
